"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const babel = require("@babel/core");
const errors = require("../errors");
const node_converter_1 = require("./node-converter");
/**
 * 将 commonjs 代码转换为 amd
 * @param originalCode commonjs 代码
 */
function transformJS(originalCode, options) {
    options = options || {};
    options.plugins = options.plugins || [];
    let ast = babel.parseSync(originalCode, options);
    let g = new RequireToImport();
    ast = g.transform(ast);
    let program = ast.program;
    // 查找代码中是否有导出，例如： exports.default = IndexPage;;
    let exportsNode = program.body.filter(o => o.type == "ExportNamedDeclaration")[0];
    if (exportsNode == null) {
        exportsNode = program.body.filter(o => o.type == "ExpressionStatement" && o.expression.type == "AssignmentExpression" ||
            o.type == "ExportNamedDeclaration")
            .map((o) => o.expression)
            .filter(o => o.left.type == "MemberExpression")
            .map(o => o.left)
            .filter(o => o.object.type == "Identifier" && o.object.name == "exports")[0];
    }
    console.assert(g.improts != null);
    // 没有 import 和 exports
    let importsCount = program.body.filter(o => o.type == "ImportDeclaration").length + g.improts.length;
    if (importsCount == 0 && exportsNode == null) {
        return originalCode;
    }
    // import "require";
    let requireImport = Nodecreator.createImportDeclaration("require", "require");
    // import "exports";
    let exportsImport = Nodecreator.createImportDeclaration("exports", "exports");
    program.body.unshift(...[requireImport, exportsImport]);
    if (g.improts.length > 0) {
        program.body.unshift(...g.improts);
    }
    // let options = {
    //     plugins: [
    //         ["@babel/transform-modules-amd", { noInterop: true }],
    //     ] as Array<any>
    // };
    // let isTaro = isTaroProgram(program);
    // if (isTaro) {
    //     options.plugins.push([
    //         "@babel/transform-react-jsx", {
    //             "pragma": "Nerv.createElement",
    //             "pragmaFrag": "Nerv.Fragment"
    //         }
    //     ])
    // }
    // else {
    //     options.plugins.push([
    //         "@babel/transform-react-jsx", {
    //             "pragma": "React.createElement",
    //             "pragmaFrag": "React.Fragment"
    //         }
    //     ])
    // }
    let r = babel.transformFromAstSync(ast, undefined, options);
    let code = (r === null || r === void 0 ? void 0 : r.code) || "/** Babel transform code fail. */";
    return code;
}
exports.transformJS = transformJS;
function isTaroProgram(program) {
    let taroImport = program.body.filter(o => o.type == "ImportDeclaration")
        .map((o) => o.source)
        .filter(o => o.value == "nervjs" || o.value == "@tarojs/taro")[0];
    return taroImport != null;
}
/**
 * 将 require 语句转换为 import 语句
 * 例如：const nervjs_1 = require("nervjs") 转换为 import * as nervjs_1 from "nervjs"
 * require("index.less") 转换为 import "index.less"
 */
class RequireToImport extends node_converter_1.NodeConverter {
    constructor() {
        super(...arguments);
        this.improts = [];
    }
    transform(node) {
        if (node == null)
            throw errors.argumentNull("node");
        if (node.type == "CallExpression" && node.callee.type == "Identifier" && node.callee.name == "require" &&
            node.arguments.length == 1 && node.arguments[0].type == "StringLiteral") {
            let moduleName = node.arguments[0].value;
            // && !moduleName.startsWith("css!")) ||
            // (moduleName.endsWith(".css") && !moduleName.startsWith("css!")) ||
            // (moduleName.endsWith(".less") && !moduleName.startsWith("css!"))
            if ((moduleName.endsWith(".scss") || moduleName.endsWith(".css") || moduleName.endsWith(".less")) && !moduleName.startsWith("css!")) {
                moduleName = `css!${node.arguments[0].value}`;
                node.arguments[0].value = moduleName;
            }
            // else if (moduleName.endsWith(".less") && !moduleName.startsWith("less!")) {
            //     moduleName = `less!${node.arguments[0].value}`;
            //     node.arguments[0].value = moduleName;
            // }
            let s = this.createImportDeclaration(moduleName);
            this.improts.push(s);
        }
        return super.transform(node);
    }
    /**
     * 将如 const nervjs_1 = require("nervjs") 的语句转换为 import * as nervjs_1 from "nervjs"
     */
    processVariableDeclaration(node) {
        if (node.declarations.length != 1) {
            return super.transform(node);
        }
        let declaration = node.declarations[0];
        if (declaration.type != "VariableDeclarator" || declaration.id.type != "Identifier") {
            return super.transform(node);
        }
        let variableName;
        variableName = declaration.id.name;
        let initNode = declaration.init;
        if (initNode == null || initNode.type != "CallExpression" || initNode.callee.type != "Identifier" || initNode.callee.name != "require") {
            return super.transform(node);
        }
        let arg = initNode.arguments[0];
        if (arg == null || arg.type != "StringLiteral") {
            return super.transform(node);
        }
        let importDeclaration = this.createImportDeclaration(arg.value, variableName);
        return importDeclaration;
    }
    /**
     * 将如 require("index.less") 的语句转换为 import "index.less"
     */
    processRequireStatement(node) {
        if (node.type == "ExpressionStatement" && node.expression.type == "CallExpression" &&
            node.expression.callee.type == "Identifier" && node.expression.callee.name == "require" &&
            node.expression.arguments.length == 1 && node.expression.arguments[0].type == "StringLiteral") {
            let moduleName = node.expression.arguments[0].value;
            let s = this.createImportDeclaration(moduleName);
            this.improts.push(s);
            return node;
        }
        return super.transform(node);
    }
    createImportDeclaration(moduleName, variableName) {
        return Nodecreator.createImportDeclaration(moduleName, variableName);
    }
}
class Nodecreator {
    static createImportDeclaration(moduleName, variableName) {
        if (!moduleName)
            throw errors.argumentNull("moduleName");
        if (moduleName.endsWith(".less")) {
            moduleName = `less!${moduleName}`;
        }
        let specifiers = [];
        if (variableName) {
            let specifier = {
                type: "ImportNamespaceSpecifier",
                local: { type: "Identifier", name: variableName },
            };
            specifiers = [specifier];
        }
        let node = {
            type: "ImportDeclaration", specifiers,
            source: { type: "StringLiteral", value: moduleName },
        };
        return node;
    }
}
